import React, { useState } from "react";
import axios from "axios";
import {
  splitTypedName,
  validateNewCaddie,
  buildCreateCaddiePayload,
} from "../../utils/addCaddieOption";
import "../css/AddCaddieModal.css";

/**
 * Creates the person and adds them to the Caddie group of the tournament
 * (POST /persons/create-with-participant). onCreated receives the saved person.
 */
const AddCaddieModal = ({ initialText, config, API_URL, onClose, onCreated }) => {
  const [form, setForm] = useState(() => ({ ...splitTypedName(initialText), email: "" }));
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const setField = (key) => (e) => setForm((prev) => ({ ...prev, [key]: e.target.value }));
  const close = () => {
    if (!saving) onClose();
  };

  const submit = async (e) => {
    e.preventDefault();
    const invalid = validateNewCaddie(form);
    if (invalid) {
      setError(invalid);
      return;
    }
    setSaving(true);
    setError("");
    try {
      const res = await axios.post(
        `${API_URL}/persons/create-with-participant`,
        buildCreateCaddiePayload(form, config)
      );
      onCreated(res.data.person);
    } catch (err) {
      setError(err.response?.data?.message || "Could not add the caddie. Please try again.");
      setSaving(false);
    }
  };

  return (
    <div
      className="add-caddie-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) close();
      }}
    >
      <form
        className="add-caddie-box"
        role="dialog"
        aria-modal="true"
        aria-label="Add new caddie"
        onSubmit={submit}
        noValidate
      >
        <button type="button" className="add-caddie-close" aria-label="Close" onClick={close}>
          &times;
        </button>
        <h5 className="add-caddie-title">Add new caddie</h5>
        <p className="add-caddie-sub">Creates the person and adds them to the Caddie group.</p>
        <div className="add-caddie-grid">
          <div className="add-caddie-field">
            <label htmlFor="add-caddie-first">First name *</label>
            <input id="add-caddie-first" value={form.name} onChange={setField("name")} autoFocus />
          </div>
          <div className="add-caddie-field">
            <label htmlFor="add-caddie-last">Last name *</label>
            <input id="add-caddie-last" value={form.lname} onChange={setField("lname")} />
          </div>
          <div className="add-caddie-field add-caddie-field--wide">
            <label htmlFor="add-caddie-email">Email *</label>
            <input
              id="add-caddie-email"
              type="email"
              value={form.email}
              onChange={setField("email")}
            />
          </div>
        </div>
        {error && <p className="add-caddie-error">{error}</p>}
        <div className="add-caddie-actions">
          <button type="button" className="btn btn-light" onClick={close} disabled={saving}>
            Cancel
          </button>
          <button type="submit" className="btn btn-success" disabled={saving}>
            {saving ? "Adding..." : "Add caddie"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddCaddieModal;
